import { render, staticRenderFns } from "./InspectionTask.vue?vue&type=template&id=340f1c78&scoped=true&"
import script from "./InspectionTask.vue?vue&type=script&lang=js&"
export * from "./InspectionTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340f1c78",
  null
  
)

export default component.exports